export default __webpack_public_path__ + "static/media/Lighthouse_Home.7c69d65d.png";